import React, { Component } from 'react'
import { Label, Col, Row, Input } from 'reactstrap'
import ModalForm from '../../comum/components/ModalForm'
import { observer } from 'mobx-react';

@observer
export default class ModalAnexoCdta extends Component {

    constructor(props) {

        super(props)

        this.controller = this.props.controller;

        this.handleSalvar = this.handleSalvar.bind(this);
    }

    handleSalvar() {
        this.controller.enviarAnexo();
        this.controller.fecharModalAnexo();
        setTimeout(() => {
            this.controller.listar();
        }, 1000);
    }

    render() {
        return (
            <ModalForm
                onClickSalvar={this.handleSalvar}
                onClickCancelar={this.controller.fecharModalAnexo}
            >
                <h2>Novo documento</h2>
                <div className="importacao-detalhes-adiciona-docs">
                    <Row>
                        <Col sm={12} md={12}>
                            <Label>Anexar arquivo</Label>
                            <Input type="file" onChange={(event) => this.controller.anexarArquivos(event)} multiple />
                        </Col>
                    </Row>
                    {/* <Row>
                        <Col xs={xs} sm={sm} md={md} lg={lg} xl={xl}>
                            <Label className={"nome-arquivo"}>Arquivo</Label>
                        </Col>
                        <Col xs={xs2} sm={sm2} md={md2} lg={lg2} xl={xl2}>
                            <Label className={"nome-arquivo"}>Tipo de documento</Label>
                        </Col>
                    </Row> */}
                    {/*  this.controller.listaArquivos.length>0
                        &&  this.controller.listaArquivos.map((arq, x) => (
                            <div key={x} className={"control"} >
                                <Row>
                                    <FormInputSimples xs={xs} sm={sm} md={md} lg={lg} xl={xl}
                                                      dado={ arq.DscArquivo }
                                                      bloqueado={true}
                                                      onChange={ () => {} } />
                                    <FormSelectSimples xs={xs2} sm={sm2} md={md2} lg={lg2} xl={xl2}
                                                       itens={ this.controllerImportacao.tiposDocumento }
                                                       dado={ arq.tipoDoc }
                                                       alerta={ !arq.tipoDoc && this.state.salvado ? "Campo obrigatório" : false }
                                                       onChange={ (event) => this.controller.setTipo(event, x) } />
                                </Row>
                                { this.controller.listaMsgs[x] ? <Label className="msg label-danger">{ this.controller.listaMsgs[x] }</Label> : "" }
                            </div>
                        ))
                     */}
                </div>
                
            </ModalForm>
        )
    }
}



// WEBPACK FOOTER //
// ./src/modules/veiculoscdta/components/ModalAnexoCdta.js